import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import Loading from '../Loading';
import toast from '../Toast';
import IconImage from '../../../common/elements/static/IconImage.svg';
import ApiService from '../../apis/ApiService';
import { COLOR } from '../Const';
import Multilingual from '../../Multilingual';

const StyledDiv = styled.div`
  ${(props) => (!props.defaultIcon ? '' : `background-color: ${COLOR.primary};`)}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .upload-btn {
    width: ${(props) => props.size};
    height: 100%;
    object-fit: contain;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  }

  .loading {
    background-color: #00000080;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const maxLength = 1920;
const maxSize = 1024 * 1024;

const UploadImages = ({ className = '', url, multi = false, size = '1.5rem', customBtn, onChange = () => {} }) => {
  const [loading, setLoading] = useState(false);

  const triggerFileInput = useRef();
  const [refreshInput, setRefreshInput] = useState(0);

  const uploadImages = (imageFiles) => {
    const uploadedImages = [];

    const callbackCheck = () => {
      if (uploadedImages.length !== imageFiles.length) {
        return;
      }
      onChange([...uploadedImages]);
      setLoading(false);
      setRefreshInput((pre) => pre + 1);
    };

    for (let file of imageFiles) {
      const data = new FormData();
      data.append('media', file);

      const { name: filename, type } = file;

      const fileType = type.split('/')[0];

      data.append('type', fileType);
      ApiService.post(url, { data, withCredentials: true })
        .then(({ data }) => {
          const { uniqid, url: fileUrl, path: filePath } = data;
          uploadedImages.push({
            uniqid,
            url: fileUrl,
            path: filePath,
            filename,
          });

          callbackCheck();
        })
        .catch((err) => {
          console.error(err);
          toast(Multilingual(`ERROR.UNKNOWN`), { status: 'error', second: 2 });
          setLoading(false);
          setRefreshInput((pre) => pre + 1);
        });
    }
    callbackCheck();
  };

  const handleFileOnChange = (e) => {
    e.preventDefault();
    if (e.target.files.length === 0) {
      return;
    }

    setLoading(true);

    const imageFiles = [];
    let imageAmount = 1;
    let imageDone = 0;
    const compressDone = () => {
      imageDone++;
      if (imageDone < imageAmount) {
        return;
      }
      uploadImages(imageFiles);
    };

    for (let file of e.target.files) {
      const { type, name } = file;
      const fileType = type.split('/')[0];
      if (fileType !== 'image') {
        return;
      }
      imageAmount++;

      const fileReader = new FileReader();
      fileReader.onload = (fileInfo) => {
        const img = new Image();
        img.src = fileInfo.target.result;
        img.onload = function () {
          const originWidth = this.width;
          const originHeight = this.height;

          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');

          let newWidth = originWidth;
          let newHeight = originHeight;
          if (newWidth > maxLength) {
            newHeight = (maxLength * newHeight) / newWidth;
            newWidth = maxLength;
          }
          if (newHeight > maxLength) {
            newWidth = (maxLength * newWidth) / newHeight;
            newHeight = maxLength;
          }

          canvas.width = newWidth;
          canvas.height = newHeight;
          context.clearRect(0, 0, newWidth, newHeight);
          context.drawImage(img, 0, 0, newWidth, newHeight);
          const toBlob = (currentQuality) => {
            canvas.toBlob(
              (blob) => {
                if (blob.size > maxSize && currentQuality > 0.5) {
                  toBlob(currentQuality - 0.5);
                  return;
                }
                imageFiles.push(new File([blob], name, { type: 'image/jpeg' }));
                compressDone();
              },
              'image/jpeg',
              currentQuality,
            );
          };
          toBlob(1.0);
        };
        img.onerror = () => {
          compressDone();
        };
      };
      fileReader.readAsDataURL(file);
    }
    compressDone();
  };

  const uploadBtnOnClick = (e) => {
    e.preventDefault();
    triggerFileInput.current.click();
  };

  return (
    <StyledDiv className={className} defaultIcon={!customBtn} size={size}>
      {/* 真實的fileupload input */}
      <input
        key={refreshInput}
        type="file"
        accept="image/*"
        multiple={multi}
        style={{ display: 'none' }}
        ref={triggerFileInput}
        onChange={handleFileOnChange}
      />
      {/* 檔案上傳按鈕 */}
      {!customBtn ? (
        <img className="upload-btn" onClick={uploadBtnOnClick} src={IconImage} alt="" />
      ) : (
        <>{customBtn(uploadBtnOnClick)}</>
      )}
      {loading && (
        <div className="loading">
          <Loading width={size} />
        </div>
      )}
    </StyledDiv>
  );
};

export default UploadImages;
